import { createSlice } from "@reduxjs/toolkit";
import { RootState } from '../store';

// Define the state interface
export interface EnumState {
  entityTypes: [] | null | any;
  sponsorTypes: [] | null | any;
}

// Initial state
const initialState: EnumState = {
  entityTypes: null,
  sponsorTypes: null,
};

// Create slice
export const enumSlice = createSlice({
  name: 'Enum',
  initialState,
  reducers: {
    // Set entity types
    setEntityTypes: (state, action) => {
      state.entityTypes = action.payload.data?.values || [];
    },
    // Set sponsor types
    setSponsorTypes: (state, action) => {
      state.sponsorTypes = action.payload.data?.values || [];
    },
    // Reset to initial state
    reset: (state) => {
      state = initialState;
    },
  },
});

// Export actions
export const { setEntityTypes, setSponsorTypes, reset } = enumSlice.actions;

// Selectors
export const getEntityTypesData = (state: RootState) => state.enum.entityTypes;
export const getSponsorTypesData = (state: RootState) => state.enum.sponsorTypes;

// Export reducer
export default enumSlice.reducer;